<div  style="margin-top: 75px;">
        <div class="row">
            <div class="col-md-3">
                <label for="docStartDate">Fecha de Inicio</label>
                <input type="date" class="form-control form-control-sm" #docStartDate required [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" name="docStartDate">
            </div>
            <div class="col-md-3">
                <label for="docEndDate">Fecha Final</label>
                <input type="date" class="form-control form-control-sm" #docEndDate required [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" name="docEndDate">
            </div>
            <div class="col-md-2">
                <label>Tipo de Doc.</label>
                <select class="form-control form-control-sm" [(ngModel)]="docType" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let item of docTypeList" [value]="item.type">{{item.name}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <label>Estado del Doc.</label>
                <select class="form-control form-control-sm" [(ngModel)]="docStatus" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let item of docStatusList" [value]="item.type">{{item.name}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <input style="visibility: collapse" />
                <button type="button" class="btn btn-outline-info" (click)='getDocuments()'>Consultar</button>
            </div>
        </div>
</div>